import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { fetchScopeStatus } from '../api/accountVerification';
import useBanner from '../hooks/useBanner';
import useUserHidden from '../hooks/useUserHidden';
import Banner from './Banner';

const AccountVerificationBanner = ({
  scope,
  source
}) => {
  const [accountStatus, setAccountStatus] = useState(undefined);
  const [fetchFinished, setFinishedFetching] = useState(false);
  const [bannerHiddenByUserFor, setBannerHiddenByUserFor] = useUserHidden();
  const {
    showBanner,
    showCta,
    alertType,
    langPath,
    closable
  } = useBanner(bannerHiddenByUserFor(scope), accountStatus);
  useEffect(() => {
    if (scope) {
      fetchScopeStatus(scope).then(setAccountStatus).catch(console.error).finally(() => setFinishedFetching(true));
    }
  }, [scope]);
  useEffect(() => {
    if (fetchFinished && !closable) {
      setBannerHiddenByUserFor(scope)(false);
    }
  }, [fetchFinished, closable]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!showBanner) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(Banner, {
    source: source,
    alertType: alertType,
    showCta: showCta,
    langPath: langPath,
    closable: closable,
    onClose: () => setBannerHiddenByUserFor(scope)(true)
  });
};

AccountVerificationBanner.propTypes = {
  scope: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired
};
export default AccountVerificationBanner;